// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d337074d","977":"58a4cf61"}[chunkId] + ".chunk.js";
};